import * as React from 'react';

export const Search = <>&#xE900;</>;

export const Down = <>&#xE901;</>;

export const Up = <>&#xE902;</>;

export const Left = <>&#xE903;</>;

export const Right = <>&#xE904;</>;

export const Start = <>&#xE905;</>;

export const End = <>&#xE906;</>;

export const UpDown = <>&#xE907;</>;

export const Tick = <>&#xE908;</>;

export const Cross = <>&#xE909;</>;

export const Plus = <>&#xE90A;</>;

export const Minus = <>&#xE90B;</>;

export const Question = <>&#xE90C;</>;

export const Menu = <>&#xE90D;</>;

export const Grab = <>&#xE90E;</>;

export const Character = {
	Search,
	Down,
	Up,
	Left,
	Right,
	Start,
	End,
	UpDown,
	Tick,
	Cross,
	Plus,
	Minus,
	Question,
	Menu,
	Grab
};
